import { render, staticRenderFns } from "./GestionePeriti.vue?vue&type=template&id=3029854c"
import script from "./GestionePeriti.vue?vue&type=script&lang=js"
export * from "./GestionePeriti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports